import { createContext, useContext, useMemo } from 'react'
import { Box, IconButton } from '@material-ui/core'
import { GridCloseIcon } from '@material-ui/data-grid'
import { IInvoice } from 'models/invoices.models'
import CFDIFinderSearch from 'components/Invoices/NewCFDI/CFDIFinderSearch/CFDIFinderSearch'
import CFDIFinderInvoicesTable from 'components/Invoices/NewCFDI/CFDIFInderInvoicesTable/CFDIFinderInvoicesTable'
import useCFDIFinderContainer, {
  IUseCFDIFinderContainer,
} from './useCFDIFinderContainer'
import './styles.scss'

export interface ICFDIFinderContainerProps {
  onSelect: (invoice: IInvoice) => void
  subtitle?: string
  title?: string
  onCancel?: () => void
}

type TCFDIFinderContainerContext = IUseCFDIFinderContainer &
  Pick<ICFDIFinderContainerProps, 'onSelect' | 'subtitle' | 'title'>

const CFDIFinderContainerContext =
  createContext<TCFDIFinderContainerContext | null>(null)

const CFDIFinderContainer = ({
  onSelect,
  onCancel,
  title = 'Nuevo CFDI',
  subtitle = 'Para comenzar, selecciona el tipo de comprobante.',
}: ICFDIFinderContainerProps) => {
  const cfdiFinderContainerState = useCFDIFinderContainer({
    onCancel,
  })

  const { handleCancel } = cfdiFinderContainerState

  const memoizedContextValue: TCFDIFinderContainerContext = useMemo(
    () => ({
      ...cfdiFinderContainerState,
      subtitle,
      title,
      onSelect,
    }),
    [cfdiFinderContainerState, subtitle, title, onSelect]
  )

  return (
    <CFDIFinderContainerContext.Provider value={memoizedContextValue}>
      <Box className="cfdi-finder-container">
        <Box className="header">
          <Box className="heading">
            <Box className="title">{title}</Box>
            <Box className="subtitle">{subtitle}</Box>
          </Box>
          <IconButton color="secondary" onClick={handleCancel}>
            <GridCloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <CFDIFinderSearch />
        <CFDIFinderInvoicesTable />
      </Box>
    </CFDIFinderContainerContext.Provider>
  )
}

export const useCFDIFinderContainerContext = () => {
  const context = useContext(CFDIFinderContainerContext)
  if (!context) {
    throw new Error(
      'useCFDIFinderContainerContext must be used within a CFDIFinderContainerContext'
    )
  }
  return context
}

export default CFDIFinderContainer
